/**
 * Try to keep this file light and load it async
 */

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.lazyClass = 'lazy';
window.lazySizesConfig.preloadClass = 'lazy--preload';
window.lazySizesConfig.loadingClass = 'lazy--loading';
window.lazySizesConfig.loadedClass = 'lazy--loaded';

import WebFont from 'webfontloader'; // Load all your fonts https://github.com/typekit/webfontloader
import 'picturefill'; // Picture & srcet polyfill https://github.com/scottjehl/picturefill
import './vendor/ls.bgset.js'; // Responsive backgrounds
import 'lazysizes'; // Lazyloading for normal and responsive images https://github.com/aFarkas/lazysizes
import './modules/lazy-helpers';

import { runTests } from './modules/ab-testing';

runTests();

WebFont.load(window.WebFontConfig);
